<template>
   <wo-layout v-if="hasPages" v-wo-align:center>
     <wo-region>
       <wo-button v-for="page in pages" :key="page.id" :class="page.class" @click.native="open(page)" :disabled="page.disabled">
         {{ page.label }}
       </wo-button>
     </wo-region>
   </wo-layout>
</template>
<script>

import _ from 'lodash'

const MAX_PAGES = 7

export default {
  name: 'PoPaging',
  props: {
    data: Object,
    value: { type: Number, default: 0 }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.data.total_count / this.data.page_size)
    },
    pages () {
      if (this.totalPages > MAX_PAGES) {
        if (this.value < MAX_PAGES - 1) {
          return _.times(MAX_PAGES, this.createPage).concat(this.createLast())
        } else if (this.value + MAX_PAGES >= this.totalPages) {
          return this.createFirst().concat(_.times(MAX_PAGES, i => this.createPage(this.totalPages - MAX_PAGES + i)))
        } else {
          return this.createFirst().concat(_.times(MAX_PAGES, i => this.createPage(this.value + i))).concat(this.createLast())
        }
      } else {
        return _.times(this.totalPages, this.createPage)
      }
    },
    hasPages () {
      return this.data && this.data.items && this.data.total_count > this.data.count
    }
  },
  methods: {
    open (page) {
      if (_.isNumber(page.value)) {
        this.$emit('input', page.value)
      }
    },
    getClass (value) {
      const selected = value === this.value ? '' : 'wo-button--secondary'
      return `wo-button--compact ${selected}`
    },
    createFirst () {
      return [this.createPage(0), this.createPlaceholder('first')]
    },
    createLast () {
      return [this.createPlaceholder('last'), this.createPage(this.totalPages - 1)]
    },
    createPage (value) {
      return {
        id: value,
        value: value,
        label: value + 1,
        class: this.getClass(value)
      }
    },
    createPlaceholder (id) {
      return {
        id: id,
        label: '...',
        disabled: true,
        class: this.getClass()
      }
    }
  }
}
</script>
<style lang="scss">
  .wo-button.wo-button--compact {
    padding: 5px 10px;
  }
</style>
